import { render, staticRenderFns } from "./button-dotted.vue?vue&type=template&id=4460642c&scoped=true"
import script from "./button-dotted.vue?vue&type=script&lang=js"
export * from "./button-dotted.vue?vue&type=script&lang=js"
import style0 from "./button-dotted.vue?vue&type=style&index=0&id=4460642c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4460642c",
  null
  
)

export default component.exports